import React, { useState } from 'react';
import { Query } from 'react-apollo';
import { Alert, Button, Input, Radio, Table } from 'antd';
import { GET_BAN_HISTORY } from '../../api/banned';

const actions = { impose: '封禁', change: '调整期限', release: '解封', clearExpired: '清理到期记录', report: '举报触发' };
const dateLabel = value => value === '2099-12-31' ? '永久' : value || '—';
const timestamp = value => new Intl.DateTimeFormat('zh-CN', {
  timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit',
}).format(new Date(value));

const columns = [
  { title: '时间（北京时间）', dataIndex: 'occurredAt', render: timestamp },
  { title: '操作', dataIndex: 'action', render: value => actions[value] || value },
  { title: '范围', dataIndex: 'isAnom', render: value => value ? '限制匿名（禁止发私信）' : '禁言' },
  { title: '原截止', dataIndex: 'previousEndDate', render: dateLabel },
  { title: '新截止', dataIndex: 'endDate', render: dateLabel },
  { title: '操作者', dataIndex: 'operator', render: (value, row) => value || (row.action === 'report' ? '系统' : '—') },
  { title: '原因', dataIndex: 'reason', render: value => value || '—' },
  { title: '举报 ID', dataIndex: 'reportId', render: value => value || '—' },
];

export default function BanHistory({ initialUserId }) {
  const [userId, setUserId] = useState(initialUserId || '');
  const [source, setSource] = useState('manual');
  const [pages, setPages] = useState([null]);
  const [invalid, setInvalid] = useState(false);

  return (
    <div className="ban-history">
      <Input.Search
        defaultValue={initialUserId}
        placeholder="输入用户 ID"
        enterButton="查询"
        onSearch={value => {
          const id = value.trim();
          const valid = /^[a-f0-9]{24}$/i.test(id);
          setInvalid(!valid);
          setUserId(valid ? id : '');
          setPages([null]);
        }}
      />
      {invalid && <Alert type="error" message="请输入有效的用户 ID" />}
      <Radio.Group value={source} onChange={event => {
        setSource(event.target.value);
        setPages([null]);
      }}>
        <Radio.Button value="manual">手动操作</Radio.Button>
        <Radio.Button value="report">举报处罚</Radio.Button>
      </Radio.Group>
      {userId && (
        <Query query={GET_BAN_HISTORY} fetchPolicy="network-only"
          variables={{ userId, source, cursor: pages[pages.length - 1] }}>
          {({ data, loading, error }) => {
            if (error) return <Alert type="error" message="历史查询失败" description={error.message} />;
            const { entries = [], nextCursor } = (data && data.banHistory) || {};
            return (
              <>
                <Table rowKey="id" size="small" pagination={false} columns={columns}
                  dataSource={loading ? [] : entries} loading={loading} scroll={{ x: 880 }}
                  locale={{ emptyText: nextCursor ? '本页无匹配记录，可继续查询更早记录' : '没有更多记录' }} />
                <div className="ban-history-pagination">
                  <Button disabled={loading || pages.length === 1}
                    onClick={() => setPages(pages.slice(0, -1))}>上一页</Button>
                  <Button disabled={loading || !nextCursor}
                    onClick={() => setPages([...pages, nextCursor])}>查询更早记录</Button>
                </div>
              </>
            );
          }}
        </Query>
      )}
    </div>
  );
}
